import { gunzipSync, strToU8, strFromU8 } from "fflate";
import { ProjectsAndCategoriesPayload } from "redmond";

// Richmond/Tysons pass the EM expense-context payload through as an opaque
// base64 string wrapping a gzipped JSON blob. Decode it once per response.
export const unzipProjectsAndCategories = (
  projectsAndCategoriesPayload: string
): ProjectsAndCategoriesPayload => {
  const compressed = strToU8(atob(projectsAndCategoriesPayload), true);
  const json = strFromU8(gunzipSync(compressed));
  return JSON.parse(json) as ProjectsAndCategoriesPayload;
};
